/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { CorporativeCard } from '..';
import { deleteCorporative, showCorporatives } from 'js/actions';
import { setCorpId } from 'js/actions/userActions';

export default function CorporativeGrid(props) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const corporatives = useSelector((state) => state.corporatives.corporatives);
  let isLoading = useSelector((state) => state.corporatives.loading);
  const { editButton, deleteButton } = props;

  const setCorporativeId = (corpId) => {
    dispatch(setCorpId({ ...corpId }));
  };

  useEffect(() => {
    dispatch(showCorporatives());
  }, []);

  const deleteCorporativeData = (corpid) => {
    Swal.fire({
      title: `${intl.formatMessage({ id: 'app.groupsCards.deleteGroupBtn.title' })} `,
      text: `${intl.formatMessage({ id: 'app.groupsCards.deleteGroupBtn.text' })} ${corpid.name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({
        id: 'app.groupsCards.deleteGroupBtn.confirmation',
      }),
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: intl.formatMessage({
            id: 'app.groupsCards.deleteGroupBtn.titleConfirmation',
          }),
          text: intl.formatMessage({
            id: 'app.groupsCards.deleteGroupBtn.textConfirmation',
          }),
          icon: 'success',
        });
        dispatch(deleteCorporative(corpid.id));
      }
    });
  };

  const getEditButton = (corporative) => {
    if (editButton == false) {
      return <div />;
    } else {
      return (
        <Link
          to={`/updateCorporative/${corporative.id}`}
          state={{ corporative: corporative, edit: true }}
        >
          <Button color="secondary" variant="outlined">
            {intl.formatMessage({ id: 'app.corporate.grid.btnEdit' })}
          </Button>
        </Link>
      );
    }
  };

  const getDeleteButton = (corpid) => {
    if (deleteButton == false) {
      return <div />;
    } else {
      return (
        <Button
          variant="outlined"
          color="error"
          onClick={() => deleteCorporativeData(corpid)}
        >
          {intl.formatMessage({ id: 'app.groupsCards.deleteGroupBtn' })}
        </Button>
      );
    }
  };

  const shortCorporatives = () => {
    const shortArray = [...corporatives];
    return shortArray.sort((a, b) =>
      a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
    );
  };

  return (
    <div>
      {isLoading || corporatives.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {corporatives.length >= 1 ? (
            <Grid2 container={true} spacing={4}>
              {shortCorporatives().map((corporative) => (
                <Grid2 key={corporative.id} size={{ lg: 3, md: 6, xs: 12 }}>
                  <Link
                    onClick={() =>
                      setCorporativeId({
                        id: corporative.id,
                        logo: corporative.logo,
                        name: corporative.name,
                      })
                    }
                    to={`/dashboard/${corporative.id}`}
                    state={corporative}
                  >
                    <CorporativeCard
                      corporative={corporative}
                      deleteButton={deleteButton}
                      editButton={editButton}
                      key={corporative.id}
                    />
                  </Link>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      pt: '10px',
                    }}
                  >
                    {getEditButton(corporative)}
                    {getDeleteButton(corporative)}
                  </Box>
                </Grid2>
              ))}
            </Grid2>
          ) : (
            <Grid2>
              <Typography>Corporativos no encontrados</Typography>
            </Grid2>
          )}
        </>
      )}
    </div>
  );
}
